/**
 * @blueprint/web — React entry point.
 *
 * The stylesheets are imported here, theme first and print last, so the cascade
 * matches the generator's single <style> block: the print rules came last there
 * and must come last here too. shell.css sits between them — it styles only the
 * screens the generator never had, and overrides no ported rule.
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/theme.css';
import './styles/shell.css';
import './styles/print.css';
import { App } from './App';

const el = document.getElementById('root');
if (!el) throw new Error('Root element #root is missing from index.html');

createRoot(el).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
